import left from './left'
import right from './right'
import up from './up'
import down from './down'
import p from './p'
import r from './r'

export default { left, down, up, right, p, r }



// WEBPACK FOOTER //
// ./src/control/todo/index.js